import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import ControlAttendanceCard from "./ControlAttendanceCard/ControlAttendanceCard";
import SelectedTypeHour, { TurnSchedule } from "./SelectedTypeHour/SelectedTypeHour";

import * as styles from "./AttendancePage.module.scss";
import { ZeusCameraModal, ZeusLoader } from "zeus-front-design-system";

import { useToast } from "../../hook/useToast";
import { useCollaborator } from "../../core/collaborator/CollaboratorContext";
import { useAuth } from "../../core/auth";
import { useBiometric } from "../../Context/Biometric/biometric.Context";
import { uploadMedia } from "../../services/uploadMedia";
import {
  CreateAttendance,
  saveUploadPictureByAttendance,
} from "../../services/talentoZeus/endpoints";
import * as env from "../../environments/config";

import ScheduleMan from "../../assets/gifs/schedule-man.gif";
import TypeHour from "../../assets/gifs/typeHour.gif";
import AttendanceLayout from "../../componets/AttendanceLayout/AttendanceLayout";
import { confirm } from "../../services/confirmServices";
import { store } from "../../app/store";
import { openConfirm } from "../../features/modal/modalSlice";

type ActionKind = "entrada" | "salida-comer" | "termino-comida" | "salida";

interface IScheduleInfo {
  type: ActionKind;
  turnoId: number | string;
}

interface Employee {
  turnos: any[];
  id: string;
  name: string;
}

type ViewState =
  | { kind: "IDLE" }
  | { kind: "SEARCHING" }
  | { kind: "SELECT_ACTION"; empId: string; employee: Employee }
  | { kind: "REGISTERING"; empId: string; action: ActionKind; employee: Employee };

type UploadResult = { url: string; key: string; etag?: string } | null;

type Gate = {
  resolve: (v: UploadResult) => void;
  reject: (e: unknown) => void;
} | null;

const cfg = process.env.REACT_APP_ENV ? ((env as any)[process.env.REACT_APP_ENV] ?? {}) : {};
const { HOST_PHOTOS } = cfg;

function getGeo(opts: PositionOptions = { enableHighAccuracy: true, timeout: 8000 }) {
  return new Promise<{ latitude: number; longitude: number }>((resolve, reject) => {
    if (!("geolocation" in navigator)) {
      reject(new Error("Geolocalización no disponible en este dispositivo."));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        resolve({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
        });
      },
      (err) => reject(err),
      opts
    );
  });
}

// const mockSchedules: TurnSchedule[] = [
//   {
//     id_turno: 1,
//     nombre_turno: "Matutino",
//     hora_inicio: "2025-12-02T08:00:00",
//     hora_fin: "2025-12-02T16:00:00",
//     hora_comida_inicio: "2025-12-02T13:00:00",
//     hora_comida_fin: "2025-12-02T14:00:00",
//     asistencias: [], // sin registros -> "pending"
//   },

//   {
//     id_turno: 2,
//     nombre_turno: "Vespertino",
//     hora_inicio: "2025-12-02T16:00:00",
//     hora_fin: "2025-12-02T23:00:00",
//     hora_comida_inicio: "2025-12-02T19:00:00",
//     hora_comida_fin: "2025-12-02T20:00:00",
//     asistencias: [
//       {
//         tipo_registro: 1,
//         fecha_registro: "2025-12-01T08:59:00",
//       },
//     ],
//   },

//   {
//     id_turno: 3,
//     nombre_turno: "Turno especial muy largo",
//     hora_inicio: "2025-12-01T09:00:00",
//     hora_fin: "2025-12-01T18:00:00",
//     hora_comida_inicio: "2025-12-01T14:00:00",
//     hora_comida_fin: "2025-12-01T15:00:00",
//     asistencias: [
//       {
//         tipo_registro: 1,
//         fecha_registro: "2025-12-01T08:59:00",
//       },
//       {
//         tipo_registro: 2,
//         fecha_registro: "2025-12-01T14:02:00",
//       },
//       {
//         tipo_registro: 3,
//         fecha_registro: "2025-12-01T14:58:00",
//       },
//       {
//         tipo_registro: 4,
//         fecha_registro: "2025-12-01T18:01:00",
//       },
//     ],
//   },
//   {
//     id_turno: 4,
//     nombre_turno: "Turno 4",
//     hora_inicio: "2025-12-01T09:00:00",
//     hora_fin: "2025-12-01T18:00:00",
//     hora_comida_inicio: "2025-12-01T14:00:00",
//     hora_comida_fin: "2025-12-01T15:00:00",
//     asistencias: [
//       {
//         tipo_registro: 1,
//         fecha_registro: "2025-12-01T08:59:00",
//       },
//       {
//         tipo_registro: 2,
//         fecha_registro: "2025-12-01T14:02:00",
//       },
//       {
//         tipo_registro: 3,
//         fecha_registro: "2025-12-01T14:58:00",
//       },
//       {
//         tipo_registro: 4,
//         fecha_registro: "2025-12-01T18:01:00",
//       },
//     ],
//   },
//   {
//     id_turno: 5,
//     nombre_turno: "Turno 5",
//     hora_inicio: "2025-12-01T09:00:00",
//     hora_fin: "2025-12-01T18:00:00",
//     hora_comida_inicio: "2025-12-01T14:00:00",
//     hora_comida_fin: "2025-12-01T15:00:00",
//     asistencias: [
//       {
//         tipo_registro: 1,
//         fecha_registro: "2025-12-01T08:59:00",
//       },
//       {
//         tipo_registro: 2,
//         fecha_registro: "2025-12-01T14:02:00",
//       },
//       {
//         tipo_registro: 3,
//         fecha_registro: "2025-12-01T14:58:00",
//       },
//       {
//         tipo_registro: 4,
//         fecha_registro: "2025-12-01T18:01:00",
//       },
//     ],
//   },
// ];

export default function AttendancePage() {
  const navigate = useNavigate();
  const toast = useToast();
  const { biometrics } = useBiometric();
  const { searchById, error: errorColaborator, restoreFromStorage } = useCollaborator();
  const { user } = useAuth();

  const [state, setState] = useState<ViewState>({ kind: "IDLE" });
  const [empId, setEmpId] = useState("");
  const [openModalImages, setOpenModalImages] = useState(false);
  const imageGateRef = useRef<Gate>();

  // Habilita el botón de búsqueda
  const canSubmit = useMemo(
    () => empId?.trim()?.length > 0 && state.kind !== "SEARCHING" && state.kind !== "REGISTERING",
    [empId, state.kind]
  );

  useEffect(() => {
    restoreFromStorage();
  }, [restoreFromStorage]);

  function safeString(v: unknown) {
    return v == null ? "" : String(v);
  }

  // --- flujo imagen / biometría ---
  const pickImageAndUpload = useCallback(() => {
    return new Promise<UploadResult>((resolve, reject) => {
      imageGateRef.current = { resolve, reject };
      setOpenModalImages(true);
    });
  }, []);

  const handleCancelImage = useCallback(() => {
    setOpenModalImages(false);
    imageGateRef.current?.reject(new Error("USER_CANCELLED"));
    imageGateRef.current = null;
  }, []);

  const handleOnCloseImageUploadModal = () => {
    confirm(
      {
        title: "¿100% Seguro?",
        subtitle:
          "Al realizar esta acción no se guardará, ni enviará la foto para confirmar tu asistencia.",
        confirmText: "Continuar",
        cancelText: "Cancelar",
      },
      () => {
        handleCancelImage();
      }
    );
  };

  const handleSubmitImage = useCallback(
    async (file: File) => {
      toast.info("Validando Información", "Por favor espera un momento...");
      const resp = await uploadMedia({ file });

      if (resp?.url) {
        setOpenModalImages(false);
        imageGateRef.current?.resolve(resp);
        imageGateRef.current = null;
      } else {
        toast.error("Intenta nuevamente.", "No se pudo subir la imagen.");
        setOpenModalImages(false);
        imageGateRef.current?.reject(new Error("UPLOAD_FAILED"));
        imageGateRef.current = null;
      }
    },
    [toast]
  );

  // --- submit de ID de colaborador ---
  const handleSubmit: React.FormEventHandler = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    setState({ kind: "SEARCHING" });

    try {
      const info = await searchById(empId);

      if (!info) {
        toast.error("No se encontró el colaborador.");
        setState({ kind: "IDLE" });
        return;
      }

      const employee: Employee = {
        id: info.idColaborador || info.identificadorApp || empId,
        name: info.nombre || "",
        turnos: info.turnos || [],
      };

      setState({
        kind: "SELECT_ACTION",
        empId,
        employee,
      });
    } catch (err: any) {
      setState({ kind: "IDLE" });
    }
  };

  // --- registro final (se llama desde SelectedTypeHour) ---
  async function registerAttendance(
    empIdParam: string,
    employee: Employee,
    action: ActionKind,
    turnoId: string | number | null
  ) {
    let upload: UploadResult | null = null;

    // si requiere foto
    if (biometrics?.take_photo) {
      try {
        upload = await pickImageAndUpload();
      } catch {
        toast.info("Se canceló la captura/carga de imagen.", "No se realizará el registro.");
        return;
      }
    }

    setState({ kind: "REGISTERING", empId: empIdParam, action, employee });

    try {
      // geolocalización
      let lat = "",
        lon = "";
      try {
        const geo = await getGeo();
        lat = safeString(geo.latitude);
        lon = safeString(geo.longitude);
      } catch {
        toast.warn("No se pudo obtener tu ubicación. Se registrará sin coordenadas precisas.");
      }

      const companyId = String(user?.companyId ?? "");
      if (!companyId) {
        toast.error("No se pudo identificar tu empresa. Reintenta o vuelve a iniciar sesión.");
        setState({ kind: "SELECT_ACTION", empId: empIdParam, employee });
        return;
      }

      const apiRes = await CreateAttendance({
        collaborator_id: employee.id,
        company_id: companyId,
        latitude: lat,
        longitude: lon,
        attendance_type: action,
        alreadyEncrypted: false,
        idTurno: turnoId,
      });
      const attendance_id = apiRes?.attendance_id;

      if (biometrics?.take_photo && upload?.url && attendance_id) {
        await saveUploadPictureByAttendance({
          attendance_id,
          user_modify: String(user?.id),
          url: `${HOST_PHOTOS}${upload.key}`,
        });
      }

      const nowISO = new Date().toISOString();
      const navPayload = {
        type: action,
        employeeName: employee.name,
        timeISO: nowISO,
      };

      sessionStorage.setItem("lastRegistration", JSON.stringify(navPayload));
      navigate("/confirm", { state: navPayload, replace: true });
      setEmpId("");
    } catch (err: any) {
      if (err.message.includes("Por favor acércate más a tu lugar de trabajo")) {
        store.dispatch(
          openConfirm({
            title: '¡Oops! Fuera de zona',
            subtitle: 'Acércate un poco más al rango de registro para poder realizar tu asistencia',
            confirmText: "Continuar"
          })
        );
        // regresamos al estado inicial
        setState({ kind: "SELECT_ACTION", empId: empIdParam, employee });
        return;
      }
      const msg =
        typeof err?.message === "string" ? err.message : "No se pudo completar el registro.";

      toast.error(humanError({ status: "error", code: "SERVER", message: msg }), msg);

      // volvemos a la selección de acción para que pueda reintentar
      setState({ kind: "SELECT_ACTION", empId: empIdParam, employee });
    }
  }

  const handleSelectedTypeHour = (type: ActionKind, turnoId: string | number | null) => {
    if (state.kind !== "SELECT_ACTION") return;

    // advertencia especial en "salida", ejemplo toast.warn
    // pero ya SIN ModalAction
    if (type === "salida") {
      // ejemplo:
      // toast.warn("Estás registrando tu salida del día.");
    }

    // console.log({ type, turnoId });

    registerAttendance(state.empId, state.employee, type, turnoId);
  };

  const handleSelectImage = () => {
    if (state.kind === "IDLE" || state.kind === "SEARCHING") return ScheduleMan;
    if (state.kind === "SELECT_ACTION") return TypeHour;
    return null;
  };

  const img = handleSelectImage();

  const isWarning =
    state.kind !== "IDLE" && state.kind !== "SEARCHING" && state.kind !== "SELECT_ACTION";

  if (state.kind === "REGISTERING") {
    return <ZeusLoader />;
  }

  return (
    <>
      {/* Modal de cámara */}
      <ZeusCameraModal
        isOpen={openModalImages}
        onClose={(type) => {
          if (type === "cancel") {
            handleOnCloseImageUploadModal();
          } else if (type === "confirm") {
            setOpenModalImages(false);
          }
        }}
        onCapture={(file) => handleSubmitImage(file as File)}
        returnAsFile
        autoCapture
        autoCaptureDelay={0}
      />

      <AttendanceLayout imageSrc={img} warning={isWarning}>
        {(state.kind === "IDLE" || state.kind === "SEARCHING") && (
          <ControlAttendanceCard
            empId={empId}
            setEmpId={setEmpId}
            canSubmit={canSubmit}
            handleSubmit={handleSubmit}
            error={errorColaborator}
          />
        )}

        {state.kind === "SELECT_ACTION" && (
          <SelectedTypeHour
            name={state.employee.name}
            schedules={state.employee.turnos ?? []}
            onSelect={handleSelectedTypeHour}
            returnToIdle={() => {
              setState({ kind: "IDLE" });
            }}
          />
        )}
      </AttendanceLayout>
    </>
  );
}

type RegisterErr = {
  status: "error";
  code: string;
  message: string;
};

function humanError(e: RegisterErr) {
  const dict: Record<string, string> = {
    DUPLICATE: "Acción ya registrada",
    OUT_OF_WINDOW: "Fuera del horario permitido",
    COOLDOWN: "Debes esperar antes de registrar de nuevo",
    LUNCH_ALREADY_STARTED: "Tu comida ya había iniciado",
    LUNCH_NOT_STARTED: "Aún no inicias comida",
    SERVER: "Error del servidor",
    NOT_FOUND: "Colaborador no encontrado",
  };
  return dict[e.code] || e.message || "No se pudo completar el registro";
}
